import React from 'react';
import PropTypes from 'prop-types';
import {
    IconButton,
    Snackbar
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MuiAlert from '@material-ui/lab/Alert';

const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const MusicSnackbar = (props) => {
    const { text, setOpen, open, severity, onClose } = props;

    const handleCloseSnackbar = async () => {
        setOpen(false);
        if (onClose) {
            await onClose();
        }
    };    

    return (
        <Snackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            open={open}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
            severity="success"
            action={
            <React.Fragment>
                <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
                <CloseIcon fontSize="small" />
                </IconButton>
            </React.Fragment>
            }
        >
            <Alert onClose={async () => await handleCloseSnackbar()} severity={severity}>
                {text}
            </Alert>
        </Snackbar>
    );
};

MusicSnackbar.propTypes = {
  className: PropTypes.string
};

export default MusicSnackbar;
